var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wt-cell",style:({'background-color': _vm.bgColor})},[_c('span',[_vm._v(_vm._s(_vm.value))]),_c('sup',{directives:[{name:"show",rawName:"v-show",value:(_vm.isComplex),expression:"isComplex"}]},[_vm._v("*")]),_c('sup',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isComplex),expression:"!isComplex"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }